export const BASEURL = `https://novocinemas-api.nuviotech.co`;

// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://novoimages.nuviotech.co/`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const Novo = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjdhYzcyY2QyLTQ2MTYtNDBkNS1iN2Q0LTExODA1ZmVjZDU1NyIsImlhdCI6MTc4OTU2MjUyN30.UA8At6MAhYZ1237gCk96dL37EszyZpvGLb72ODMK7NE`
export const TOKEN = Novo



// WEBPACK FOOTER //
// ./src/config/index.js